<template>
  <div class="transaction-item-accordion">
    <div
      class="transaction-item-accordion__title"
      :class="{ active: isContentOpened }"
      @click="toggleContent"
    >
      <div
        class="transaction-item-accordion__title-text"
        :class="{ active: isContentOpened }"
      >
        {{ title }}
      </div>
      <div
        class="transaction-item-accordion__title-caret"
        :class="{ rotated: isContentOpened }"
      >
        <svg
          width="4"
          height="7"
          viewBox="0 0 4 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.2626 3.39644L0.823783 0.957668C0.767376 0.901217 0.692078 0.870117 0.61179 0.870117C0.531501 0.870117 0.456203 0.901217 0.399796 0.957668L0.220194 1.13723C0.103326 1.25423 0.103326 1.44439 0.220194 1.56121L2.26813 3.60915L0.217922 5.65935C0.161515 5.7158 0.130371 5.79106 0.130371 5.8713C0.130371 5.95163 0.161515 6.02689 0.217922 6.08338L0.397524 6.2629C0.453975 6.31935 0.529229 6.35045 0.609517 6.35045C0.689806 6.35045 0.765104 6.31935 0.821511 6.2629L3.2626 3.8219C3.31914 3.76527 3.35019 3.68966 3.35002 3.60928C3.35019 3.52859 3.31914 3.45302 3.2626 3.39644Z"
            fill="#666D79"
          />
        </svg>
      </div>
    </div>
    <div class="transaction-item-accordion__content" v-if="isContentOpened">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TransactionsTableAccordionHelper',
  props: {
    title: {
      type: String,
    },
  },
  data() {
    return {
      isContentOpened: false,
    }
  },
  methods: {
    toggleContent() {
      this.isContentOpened = !this.isContentOpened
    },
  },
}
</script>

<style lang="scss" scoped>
.transaction-item-accordion {
  &__title {
    padding: 5px 15px;

    background: rgba(248, 251, 255, 0.5);
    display: flex;
    align-items: center;
    cursor: pointer;
    border-bottom: 1px solid rgba(174, 181, 190, 0.3);

    &.active {
      border-bottom-color: transparent;
    }

    &-text {
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      text-transform: uppercase;
      color: rgba(#27365b, 0.7);
    }

    &-caret {
      width: 7px;
      height: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 10px;

      &.rotated {
        transform: rotate(90deg);
      }

      svg {
        max-width: 100%;
      }
    }
  }

  &__content {
    border-bottom: 1px solid rgba(174, 181, 190, 0.3);
  }
}
</style>
